import { action } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useControllers } from '../../hooks/controller.hooks';
import { useProps, useStore } from '../../utils/mobx.utils';
import TimeframePicker from '../TimeframePicker/TimeframePicker';
import './BaseCalendarHeader.scss';
import BaseCalendarWeekHeader from './BaseCalendarWeekHeader';
function BaseCalendarHeader(props) {
    var p = useProps(props);
    var UI = useControllers().UI;
    var s = useStore(function () { return ({
        get calendar() { return p.state; },
        get mode() { return s.calendar.mode; },
        get startDate() { return s.calendar.startDate; },
        get shouldShowWeekHeader() {
            return !s.calendar.shouldDisplayAsTimeline && (s.mode === 'week' || s.mode === 'month');
        },
    }); });
    var handleNavigate = action(function (newStartDate) {
        s.calendar.startDate = newStartDate;
        p.onNavigate && p.onNavigate(newStartDate, s.calendar);
    });
    return React.createElement(Observer, { children: function () { return (React.createElement("header", { className: "BaseCalendarHeader" },
            React.createElement(TimeframePicker, { startDate: s.startDate, onNavigate: handleNavigate, unit: s.mode, icon: "chevron", iconVariant: "filled" }),
            s.shouldShowWeekHeader && React.createElement(BaseCalendarWeekHeader, { format: UI.onlyPhones ? 'singleChar' : 'long' }))); } });
}
export default BaseCalendarHeader;
